/* eslint-disable typescript-sort-keys/interface */
import { type ComponentType, type JSX } from 'react';
import { Context as ResponsiveContext } from 'react-responsive';

export interface Breakpoints {
  desktop: number;
  desktopLg: number;
  desktopMd: number;
  phoneLg: number;
  phoneSm: number;
  tablet: number;
}

export const breakpoints: Breakpoints = {
  desktop: 1024,
  desktopLg: 1360,
  desktopMd: 1200,
  phoneLg: 600,
  phoneSm: 320,
  tablet: 768,
};

export interface Media {
  xs: 376;
  s: 737;
  m: 981;
  l: 1024;
  xl: 1281;
  xxl: 1361;
}

export const media: Media = {
  l: 1024,
  m: 981,
  s: 737,
  xl: 1281,
  xs: 376,
  xxl: 1361,
};

export const isDesktopQuery = {
  query: `(min-width: 1024px)`,
};

// query created to exclude ipad pro
export const isJustDesktopQuery = {
  query: `(min-width: 1025px)`,
};

export const isTabletQuery = {
  query: `(min-width: 768px) and (max-width: 1023px)`,
};

export const isTabletOrDesktopQuery = {
  query: `(min-width: 768px)`,
};

export const isTabletOrMobileQuery = {
  query: `(max-width: 1023px)`,
};

export const isMobileQuery = {
  query: `(max-width: 599px)`,
};

export const isSmallMobileQuery = {
  query: `(max-width: 375px)`,
};

export interface ResponsiveProps {
  deviceType?: string; // MOBILE, TABLET, DESKTOP
}

export function withMediaQueries<T = Record<string, unknown>>(
  Component: ComponentType<ResponsiveProps & T>,
): (props: ResponsiveProps & T) => JSX.Element {
  const ResponsiveComponent = (props: ResponsiveProps & T) => {
    // If on client, don't bother passing device width via context
    if (typeof window !== 'undefined') {
      return <Component {...props} />;
    }

    const { deviceType } = props;

    const deviceWidth = deviceType === 'MOBILE' ? 320 : deviceType === 'TABLET' ? 768 : 1024;

    return (
      <ResponsiveContext.Provider value={{ width: deviceWidth }}>
        <Component {...props} />
      </ResponsiveContext.Provider>
    );
  };

  return ResponsiveComponent;
}
